import { Star } from "lucide-react";

export default function SuccessStartsHere() {
  return (
    <div style={{ padding: "16px", paddingBottom: "40px" }} data-testid="success-page">
      <div
        style={{
          backgroundColor: "var(--surface)",
          borderRadius: "16px",
          padding: "20px",
          border: "1px solid var(--border)",
        }}
      >
        <div
          className="flex items-center justify-center"
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "14px",
            backgroundColor: "var(--gold)",
          }}
        >
          <Star
            size={22}
            color="var(--primary-dark)"
            fill="var(--primary-dark)"
            strokeWidth={0}
          />
        </div>
        <p
          style={{
            fontSize: "11px",
            fontWeight: 800,
            letterSpacing: "1.5px",
            color: "var(--primary)",
            marginTop: "16px",
            textTransform: "uppercase",
          }}
        >
          Birmingham City Schools
        </p>
        <h2
          style={{
            fontSize: "24px",
            fontWeight: 800,
            color: "var(--primary-dark)",
            marginTop: "8px",
            lineHeight: "30px",
          }}
        >
          Preparing every student for success in college, career, and life.
        </h2>
        <p
          style={{
            fontSize: "14px",
            color: "var(--text-muted)",
            lineHeight: "22px",
            marginTop: "12px",
          }}
        >
          "Success Starts Here" is the strategic plan of Birmingham City
          Schools. Under the leadership of Superintendent Dr. Mark Sullivan,
          the district is guided by a vision of nurturing, guiding, and
          empowering every learner — ensuring access to high-quality
          instruction, modern technology, and professional learning that drives
          meaningful outcomes for students and educators alike.
        </p>

        <div
          className="grid grid-cols-3 text-center"
          style={{
            marginTop: "20px",
            paddingTop: "16px",
            borderTop: "1px solid var(--border)",
            gap: "12px",
          }}
        >
          {[
            { word: "Nurture", sub: "EVERY LEARNER", color: "var(--primary)" },
            { word: "Guide", sub: "EVERY STEP", color: "var(--maroon)" },
            { word: "Empower", sub: "EVERY EDUCATOR", color: "var(--gold)" },
          ].map((it) => (
            <div key={it.word}>
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: 800,
                  color: it.color,
                }}
              >
                {it.word}
              </p>
              <p
                style={{
                  fontSize: "10px",
                  fontWeight: 700,
                  letterSpacing: "1.5px",
                  color: "var(--text-muted)",
                  marginTop: "4px",
                }}
              >
                {it.sub}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
